// Model
import { Model } from "@mgs/ci2019-common/src/models/model/Model";
import { FahrzeugModellDTO } from "./FahrzeugModellDTO";

interface FahrzeugModellChildren {
  key: number;
  name: string;
  note: string;
  long: string;
  description: string;
}

export class FahrzeugModell extends Model<FahrzeugModellDTO> {
  public key!: number;
  public sparte!: number;
  public name!: string;
  public note!: string;
  public long!: string;
  public description!: string;
  public image!: string;
  public has_aufbaurichtlinien!: boolean;
  public has_abh_infos!: boolean;
  public children?: FahrzeugModellChildren[];

  constructor(initial?: Partial<FahrzeugModellDTO>) {
    super();
    this.init(initial);
  }
}
